import React from 'react';
import { CheckCircle2Icon, ZapIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { instantAccessItems } from '../data/instantAccess';
export function InstantAccessSection() {
  return <section className="bg-brand-paper px-4 py-20 md:py-28" data-id="element-97" data-mp="1mf2ctd0ek2u7">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-98" data-mp="1mgnahbi0k1wa">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-brand-terracotta/25 text-brand-terracottaInk" data-id="element-99" data-mp="1hnalh09f9t30">
          <ZapIcon className="h-6 w-6" aria-hidden="true" data-id="element-100" data-mp="1rdvs9az923x0" />
        </div>
        <h2 className="mb-12 text-3xl font-black text-brand-slate md:text-4xl" data-id="element-101" data-mp="1rdm29ne7fwrb">Que recevez-vous immédiatement ?</h2>
        <div className="space-y-3 text-left" data-id="element-102" data-mp="25bamct0g6zvb">
          {instantAccessItems.map(item => <div key={item} className="flex items-center gap-4 rounded-2xl border border-brand-sand bg-brand-sandSoft p-5" data-id="element-103" data-mp="20ch4ypi1iopv">
              <CheckCircle2Icon className="h-6 w-6 shrink-0 text-brand-sageInk" aria-hidden="true" data-id="element-104" data-mp="61ub7kmjgp0x" />
              <span className="font-semibold" data-id="element-105" data-mp="2n2ztfio53m6b">{item}</span>
            </div>)}
        </div>
        <p className="mt-10 font-serif text-2xl font-bold italic text-brand-terracottaInk" data-id="element-106" data-mp="2s1jg5lak51zq">
          Aucun matériel supplémentaire à acheter séparément pour compléter votre année.
        </p>
      </Reveal>
    </section>;
}